import { Flex, Link } from '@chakra-ui/react'
import { Mobile } from '../../icons'
import { useMemo } from 'react'

const mobilePhoneSegmentsRegex = /^(\d{3})(\d{3})(\d{3})$/
export const MobilePhone = ({ mobilePhone, showIcon = true }: { mobilePhone: string, showIcon?: boolean }) => {
  const mobilePhoneSegments = useMemo(() => mobilePhone && mobilePhone.match(mobilePhoneSegmentsRegex), [mobilePhone])

  const formattedNumber = useMemo(() => mobilePhoneSegments ?
    `${mobilePhoneSegments[1]} ${mobilePhoneSegments[2]} ${mobilePhoneSegments[3]}`
    :
    mobilePhone, [mobilePhoneSegments, mobilePhone])

  return (
    <Flex sx={{ gap: 2, flexWrap: 'wrap' }}>
      {showIcon && <Mobile color="secondary.500" />}
      <Link href={`tel:${mobilePhone}`} title={`Zavolat ${formattedNumber}`}>{formattedNumber}</Link>
    </Flex>
  )
}